import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'antd';
import { selectors, actions, useCanAddIndividualMeters } from '../../../model';
import FormItem from '../../ui/FormItem/FormItem';
import { importTypes } from '../../../config/import';
import { uploadingFieldNames } from '../../../config/uploadingStep';

const { selectUploadingStepValue, selectUploadingStepError } = selectors;
const { importTypeChangeAction } = actions;

const typeName = uploadingFieldNames.importType;

const valueSelector = (state) => selectUploadingStepValue(state, typeName);
const errorSelector = (state) => selectUploadingStepError(state, typeName);

const getOptions = ({ availableImport, canAddIndividualMeters }) => {
  const options = {
    [importTypes.owners]: 'Собственники',
    [importTypes.personalAccounts]: 'Лицевые счета',
  };

  if (availableImport) {
    options[importTypes.personalAccountsByCompanies] =
      'Лицевые счета по УК';
  }

  if (canAddIndividualMeters) {
    options[importTypes.individualMeters] = 'ИПУ';
  }

  return options;
};

const FieldWrapper = ({ children }) => {
  const errors = useSelector(errorSelector);

  return (
    <FormItem
      required
      label="Что загружаем"
      errors={errors}
    >
      {children}
    </FormItem>
  );
};

const ImportTypeSelect = ({ availableImport }) => {
  const canAddIndividualMeters = useCanAddIndividualMeters();
  const options = getOptions({ availableImport, canAddIndividualMeters });

  const value = useSelector(valueSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !availableImport &&
      value === importTypes.personalAccountsByCompanies
    ) {
      dispatch(importTypeChangeAction());
    }
  }, [availableImport, dispatch, value]);

  const handleChange = (value) => dispatch(importTypeChangeAction(value));

  return (
    <FieldWrapper>
      <Select
        value={value}
        style={{ width: '100%' }}
        onChange={handleChange}
        placeholder="Выберите тип импорта"
      >
        {Object.entries(options).map(({ 0: id, 1: name }) => (
          <Select.Option
            value={id}
            key={id}
          >
            {name}
          </Select.Option>
        ))}
      </Select>
    </FieldWrapper>
  );
};

export default ImportTypeSelect;
